/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { CustomerCreditDto } from '@well/domain';
import { HttpClient } from '@angular/common/http';
import {EnvironmentService} from "@irian-ro/util-environment";
import { Observable } from 'rxjs';
import { AbstractResourceService, JsonApiResource, QueryParams } from '@irian-ro/abstract-resource';

@Injectable({
  providedIn: 'root'
})
export class CustomerCreditResourceService extends AbstractResourceService<any,
  CustomerCreditDto,
  any,
  any> {
  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('customerCreditUrl'),
      CustomerCreditDto,
      CustomerCreditDto
    );
  }

  findHistoricalCredits(uuid: string, query?: any, additionalParams?: any): Observable<JsonApiResource<any[], any>> {
    const queryString = new QueryParams(
      query,
      additionalParams ? additionalParams : []).toString();

    return this.httpClient?.get(`${this.url}/versions/${uuid}${queryString}`).pipe(this.mapToListOfObjects());
  }

  findOneByCustomerUuid(id: any): Observable<JsonApiResource<CustomerCreditDto, any>> {
    return this.httpClient?.get(`${this.url}/customer/${id}`,{headers: this.headers}).pipe(this.getDtoMapper());
  }

}
